import { useRouteMatch } from "react-router-dom";

export const useProjectId = () : string => {
    const match = useRouteMatch<{ projectId: string }>("/projects/:projectId");
    const projectId = match?.params.projectId || "";
    return projectId;
}